import styled from 'styled-components';

export const Container = styled.header`
  padding: 8px 0;
  background: #fff;
`;

export const Profile = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  //max-width: 1120px;

  margin-left: 88px;

  span {
    font-family: Roboto Condensed;
    font-size: 16px;

    color: #919191;

    strong {
      font-weight: 600;
      color: #2c73e9;
    }
  }
`;
